exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.configurationErrorDiv {\n  background-color: #ffffff;\n}\n", ""]);

// exports
